import {Person} from './Person';
import {MoreAboutDocument} from './common/MoreAboutDocument';

export class Document {
  id: number;
  type: number;
  subject: string;
  personId: number;
  workflowId: number;
  personByPersonId: Person;
  finished: number;
  hashIdentifier: string;
  freelySignature: boolean;
  hasMultipleAttachments: number;
  closedStamping: boolean;
  /**
   * Estado para saber el documento fue cargado.
   */
  loaded: boolean;
  stateId: number;
  reasonModification: string;
  createAt: string;
  active: number;
  /**
   * Descripción del movito de error de carga
   */
  descriptionLoadError: string;
  // tslint:disable-next-line:variable-name
  _links: any;
  // tslint:disable-next-line:variable-name
  _more: MoreAboutDocument;
}
